import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { DeviceInfoDto } from '../../dto/DeviceInfoDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApiVersion } from '../../utils/utils';
import { getApi } from '../getApi';

export const apiUpdateInfo = async (dto?: DeviceInfoDto) => {
  const apiVersion = getApiVersion();
  const params: IApiParams = {
    url: `/info/updateInfo${apiVersion}.php`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
